import { ControlListProps } from "@bsm/component";

export const useEmailConfigureForm = (id?: number): ControlListProps => {
    return {
        data: {
            forms: [
                {
                    type: "hidden",
                    name: "id",
                },
                {
                    type: "text",
                    name: "serverName",
                    label: "Server name",
                    required: true,
                },
                {
                    type: "text",
                    name: "userName",
                    label: "Username",
                    required: true,
                },
                {
                    type: "password",
                    name: "password",
                    label: "Password",
                    required: true,
                },
                {
                    type: "text",
                    name: "portSslTls",
                    label: "Port for SSL/TLS",
                    required: true,
                },
                {
                    type: "text",
                    name: "portTlsStarttls",
                    label: "Port for TLS/STARTTLS",
                    required: true,
                },
            ],
            value: {},
            graphQL: {
                entity: "smtpconfig",
                entityId: id,
            },
            next: {
                label: "Save",
                className: "btn btn-primary text-white",
            },
            back: {
                label: "Cancel",
            },
        },
        id: "invoice-email-form",
    };
};
